import {ApiArticle} from '@/model/Article';
import {ApiRequestOptions, CombinedApiResponse, doApiRequest, Method, Module} from '..';
import {ApiCombination, ApiComparison, ApiSimpleFunction, Query} from '../meta/odata';
import {ApiArticleStock} from '@/model/ArticleStock';

export enum ResourceArtikel {
  Artikel = '/Artikel',
}

export enum ArtikelAction {
  ArtikelSuche = '/Artikelsuche/{suchbegriff}',
}

export async function findArticles(sWord: string): Promise<CombinedApiResponse<ApiArticle[]>> {
  const sWordLower = sWord.toLowerCase();
  const options: ApiRequestOptions = {
    module: Module.Artikel,
    resource: ResourceArtikel.Artikel,
    method: Method.Get,
    limit: 50,
    filters: [
      ApiComparison.Equals, {field: 'Gesperrt'}, 'N',
    ],
    select: new Set(['Artikelnr', 'EANCode', 'Bezeichnung1', 'Bezeichnung2', 'Matchcode', 'Matchcode2']),
    action: ArtikelAction.ArtikelSuche,
    actionParameters: {
      suchbegriff: encodeURIComponent(sWordLower),
    },
  };

  const response = await doApiRequest(options);

  return [response.Data, response.CountAll];
}

export interface ArticleOptionsGet {
  mitBeschreibung?: boolean;
  mitArtikelPreise?: boolean;
}

export async function getArticle(id: string, options: ArticleOptionsGet = {}): Promise<CombinedApiResponse<ApiArticle | null>> {
  const select = new Set([
    'ArtikelNr',
    'Bezeichnung1',
    'Bezeichnung2',
    'EANCode',
    'GruppeBezeichnung',
    'EinheitBezeichnung',
    'EinheitBezeichnungLang',
    'Gewicht',
    'SerienNummer',
    'ChargenNummer',
    'HauptGebinde',
    'ArtikelEAN',
    'ArtikelGebinde',
    'ArtikelPaletten',
    'VerfuegbareChargen',
    'VerfuegbareNVEs',
    'LetztesEKDatum',
    'LetztesVKDatum',
    'PE1',
  ]);

  const expand = {
    'ArtikelEAN': null,
    'ArtikelPaletten': null,
  } as Record<string, Query | null>;

  if (options.mitBeschreibung) {
    select.add('Beschreibung');
  }

  if (options.mitArtikelPreise) {
    select.add('ArtikelPreise');
    expand['ArtikelPreise'] = null;
  }

  const response = await doApiRequest({
    module: Module.Artikel,
    resource: ResourceArtikel.Artikel,
    method: Method.Get,
    // limit: 1,
    filters: [
      ApiCombination.And,
      [ApiComparison.Equals, {field: 'ArtikelNr'}, id],
      [ApiComparison.Equals, {field: 'Gesperrt'}, 'N'],
    ],
    select: select,
    expand: expand,
  });

  return response.Data?.length ? [response.Data[0]] : [null];
}

export async function getArticleStock(
    artikelNr: string,
): Promise<CombinedApiResponse<ApiArticleStock[]>> {
  console.log('article stock');
  const response = await doApiRequest<ApiArticleStock[]>({
    module: Module.Artikel,
    resource: ResourceArtikel.Artikel,
    method: Method.Get,
    apply: [
      ApiSimpleFunction.GroupBy,
      {field: '(Niederlassung, Lagerhalle)'},
      [ApiSimpleFunction.Aggregate, {field: 'BestandPhysikalisch with sum as BestandPhysikalisch, MengeBestellt with sum as MengeBestellt, MengeReserviert with sum as MengeReserviert'}],
    ],
    id: `${artikelNr}/bestand`,
  });

  return [response.Data, response.CountAll];
}
